import { createContext, useContext } from 'react';
import { type LiabilityInsurance, type License } from '../../../interfaces';

interface CredentialingContextType {
  isInsuranceDocumentExpiring: boolean;
  isInsuranceDocumentExpired: boolean;
  setLiabilityInsuranceHandleRenew: (handleRenew: (() => void) | null) => void;
  handleLiabilityInsuranceRenew: () => void;
  liabilityInsurance?: LiabilityInsurance;
  refreshCredentialing: () => void;
  credentialsLoading: boolean;
  licenses: License[];
  expiringLicenses: number[];
  expiredLicenses: number[];
}

const CredentialingContext = createContext<CredentialingContextType | undefined>(undefined);

export const useCredentialing = () => {
  const context = useContext(CredentialingContext);
  if (context === undefined) {
    throw new Error('useCredentialing must be used within a CredentialingProvider');
  }
  return context;
};

export default CredentialingContext;
